module.exports = __webpack_public_path__ + "static/media/ZETH.ed8a24f3.svg";